require.register("app/search/Modal", function(exports, require, module){
  $0
  
});

